{
  "name": "@srgssr/live-dvr-time-display",
  "version": "1.0.0",
  "license": "MIT",
  "author": "SRG SSR",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/SRGSSR/pillarbox-web-suite.git"
  },
  "publishConfig": {
    "access": "public"
  },
  "homepage": "https://github.com/SRGSSR/pillarbox-web-suite/tree/main/packages/live-dvr-time-display#readme",
  "type": "module",
  "main": "dist/live-dvr-time-display.cjs",
  "browser": "dist/live-dvr-time-display.umd.min.js",
  "module": "dist/live-dvr-time-display.js",
  "style": "./dist/live-dvr-time-display.min.css",
  "exports": {
    ".": {
      "import": "./dist/live-dvr-time-display.js",
      "require": "./dist/live-dvr-time-display.cjs"
    },
    "./*": "./*"
  },
  "files": [
    "dist/*",
    "scss/*"
  ],
  "keywords": [
    "video.js",
    "player"
  ],
  "scripts": {
    "clean": "rimraf dist",
    "build": "npm-run-all clean build:*",
    "build:css": "sass ./scss/live-dvr-time-display.scss:dist/live-dvr-time-display.min.css --style compressed --source-map --load-path node_modules",
    "build:lib": "vite build --config vite.config.lib.js",
    "build:umd": "vite build --config vite.config.umd.js",
    "github:page": "vite build",
    "release:ci": "semantic-release",
    "start": " vite --port 4200 --open",
    "test": "vitest run --silent --coverage --coverage.reporter text"
  },
  "peerDependencies": {
    "video.js": "^8.0.0"
  },
  "devDependencies": {
    "@srgssr/pillarbox-web": "^1.24.1"
  }
}
